const columnData = [
  {
    header: "سال زراعی",
    accessorKey: "crop_year_name",
  },
  {
    header: "ردیف",
    accessorKey: "id",
    enableColumnFilter: false,
    cell: (cell: any) => {
      return <span>{cell.row.index + 1}</span>;
    },
  },
  {
    header: "نام کشاورز",
    accessorKey: "farmer_name",
    enableColumnFilter: false,
  },
  {
    header: "کارخانه",
    accessorKey: "factory_name",
    enableColumnFilter: false,
  },
  {
    header: () => (
      <div className="flex items-center gap-1">
        <span>تاریخ </span>
      </div>
    ),
    accessorKey: "date",
    enableColumnFilter: false,
  },
  {
    header: () => (
      <div className="flex items-center gap-1">
        <span> شماره بارنامه </span>
      </div>
    ),
    accessorKey: "load_number",
    enableColumnFilter: false,
  },
  {
    header: "نام راننده",
    accessorKey: "driver_name",
    enableColumnFilter: false,
  },
  {
    header: "شماره همراه",
    accessorKey: "phone_number",
    enableColumnFilter: false,
  },
  {
    header: () => (
      <div className="flex items-center gap-1">
        <span> وزن کل (کیلوگرم)</span>
      </div>
    ),

    accessorKey: "total_weight",
    enableColumnFilter: false,
    cell: (cell: any) => {
      return <span>{cell.getValue().toLocaleString()}</span>;
    },
  },
  {
    header: () => (
      <div className="flex items-center gap-1">
        <span> وزن خاک (کیلوگرم) </span>
      </div>
    ),

    accessorKey: "dirt_weight",
    enableColumnFilter: false,
    cell: (cell: any) => {
      return <span>{cell.getValue().toLocaleString()}</span>;
    },
  },
  {
    header: "وزن آفت (کیلوگرم)",
    accessorKey: "pest_weight",
    enableColumnFilter: false,
    cell: (cell: any) => {
      return <span>{cell.getValue().toLocaleString()}</span>;
    },
  },
  {
    header: "وزن خالص (کیلوگرم)",
    accessorKey: "pure_weight",
    enableColumnFilter: false,
    cell: (cell: any) => {
      return <span>{cell.getValue().toLocaleString()}</span>;
    },
  },
  {
    header: "قند چغندر",
    accessorKey: "sugar_beet_polarity",
    enableColumnFilter: false,
  },
  {
    header: "قیمت هر کیلو",
    accessorKey: "price_per_kilo",
    enableColumnFilter: false,
    cell: (cell: any) => {
      return <span>{cell.getValue().toLocaleString()}</span>;
    },
  },
  {
    header: "کمک  کرایه",
    accessorKey: "rent_help",
    enableColumnFilter: false,
    cell: (cell: any) => {
      return <span>{cell.getValue().toLocaleString()}</span>;
    },
  },
  {
    header: "کرایه حمل",
    accessorKey: "transportation_cost",
    enableColumnFilter: false,
    cell: (cell: any) => {
      return <span>{cell.getValue().toLocaleString()}</span>;
    },
  },
  {
    header: "بهای قند سهمیه",
    accessorKey: "quota_sugar_price",
    enableColumnFilter: false,
    cell: (cell: any) => {
      return <span>{cell.getValue().toLocaleString()}</span>;
    },
  },
  {
    header: "بهای تفاله سهمیه",
    accessorKey: "quota_pulp_price",
    enableColumnFilter: false,
    cell: (cell: any) => {
      return <span>{cell.getValue().toLocaleString()}</span>;
    },
  },
  {
    header: "  خالص پرداختی ",
    accessorKey: "pure_payable",
    enableColumnFilter: false,
    cell: (cell: any) => {
      return <span>{cell.getValue().toLocaleString()}</span>;
    },
  },
];

export default columnData;
